import { observer } from "mobx-react-lite";
import { useInjection } from "../../react-binding";
import { BankService } from "../../services/Bank/BankService";
import { Envelope, Globe2, TelephoneFill } from "react-bootstrap-icons";
import { useState } from "react";
import './PrintFooter.scss';

interface PrintHeaderProps {
    hideDetails?: boolean;
}

export const PrintFooter = observer((props: PrintHeaderProps) => {
    const [isSafari, setIsSafari] = useState(
        /^((?!chrome|android|crios|fxios|edgios|edg|opera|opr).)*safari/i.test(navigator.userAgent)
    );
    const bankService = useInjection(BankService) as BankService;

    return (
        <div
            className={`print-visible print-footer-main w-full ${isSafari ? "relative" : "fixed bottom-0"} flex`}
        >
            <div className="print-footer">
                    <div className="details-section">
                        {bankService.dataService.wordPressUIData?.name && (
                            <span className="detail">
                                {bankService.dataService.wordPressUIData?.name}
                            </span>
                        )}
                        {bankService.dataService.wordPressUIData?.telNumber  && (
                            <span className="detail">
                                <TelephoneFill className="icon" />
                                {bankService.dataService.wordPressUIData?.telNumber}
                            </span>
                        )}
                        {bankService.dataService.wordPressUIData?.email && (
                            <span className="detail">
                                <Envelope className="icon" />
                                {bankService.dataService.wordPressUIData?.email}
                            </span>
                        )}

                        {bankService.dataService.wordPressUIData?.url && (
                            <span className="detail">
                                <Globe2 className="icon" />
                                {bankService.dataService.wordPressUIData?.url}
                            </span>
                        )}
                    </div>
            </div>
        </div>
    );
})